const CHECKOUT_LEAGUE_STORAGE_KEY = 'lsc_checkout_league_id';

export function rememberCheckoutLeagueId(leagueId?: string): void {
  if (typeof window === 'undefined') return;
  const normalized = leagueId?.trim();
  if (normalized) {
    window.sessionStorage.setItem(CHECKOUT_LEAGUE_STORAGE_KEY, normalized);
    return;
  }
  window.sessionStorage.removeItem(CHECKOUT_LEAGUE_STORAGE_KEY);
}

export function readCheckoutLeagueId(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const fromStorage = window.sessionStorage.getItem(CHECKOUT_LEAGUE_STORAGE_KEY)?.trim();
  return fromStorage || undefined;
}

export function clearCheckoutLeagueId(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(CHECKOUT_LEAGUE_STORAGE_KEY);
}
